import { render, staticRenderFns } from "./challengeCritiqueDetail.vue?vue&type=template&id=da737d24&"
import script from "./challengeCritiqueDetail.vue?vue&type=script&lang=js&"
export * from "./challengeCritiqueDetail.vue?vue&type=script&lang=js&"
import style0 from "./challengeCritiqueDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports